import useScreen from "Hooks/useScreen";
import { LeftColumn, LottieContainer } from "../style";
import {
    LogoContainer,
    MainTitle,
    RightColumn,
    SubTitle,
    Titles,
} from "../style"
import BackButton from "./BackButton";
import { ReactComponent as SymphonyLogo } from 'assets/images/logo.svg';
import Lottie from 'react-lottie';
import GetStartedLottie from 'assets/images/lotties/GetStarted.json';
import ButtonSymphony from "elements/ButtonSymphony";
import FixedButtonContainer from "./NewOnboarding/FixedButtonContainer";
import SpotifyArtistSearch from "components/shareable/SpotifyArtistSearch";
import SocialConnectionsButtonsWithModals from "components/shareable/SocialConnectionsButtonsWithModals";
import useOnboarding from "Hooks/useOnboarding";
import { DESCRIPTION_INIT_TEXT, OnboardingAccountTypes } from "modules/Const";
import { useHistory } from "react-router-dom";
import useCurrentBrand from "Hooks/useCurrentBrand";

const GetStartedFindBrand = () => {
    const history = useHistory()
    const { mobileView } = useScreen();
    const { getAffiliatePartnerDetails } = useCurrentBrand()
    const {
        showBackButton,
        handleGoBack,
        isFirstTimeOnboarding,
        currentAccountType,
        handleGoNext,
        // NOTE: Spotify
        setSelectedSpotifyArtist,

        // NOTE: TikTok
        selectedTikTokProfile,
        setSelectedTikTokProfile,

        // NOTE: Instagram
        selectedInstagramProfile,
        setSelectedInstagramProfile,

        setSignupWithoutProfileName,
    } = useOnboarding();

    let titleText = 'Get Started'
    let descriptionText = DESCRIPTION_INIT_TEXT
    let partnerType = getAffiliatePartnerDetails()

    if (partnerType
        // && !showBackButton
    ) {
        const partnerName = partnerType.partnerName
        descriptionText = `We're excited to support the ${partnerName} community. Setup your account to start growing your fanbase with Symphony.`
    }

    let basicTextOptions = {
        titleText: 'Get Started',
        descriptionText: DESCRIPTION_INIT_TEXT,
        sectionTitle: 'Enter your artist name or Spotify URL',
    }

    if (isFirstTimeOnboarding()) {
        if (currentAccountType === OnboardingAccountTypes.CREATOR) {
            basicTextOptions = {
                titleText: 'Get Started',
                descriptionText: DESCRIPTION_INIT_TEXT,
                sectionTitle: `Let's setup your profile. Enter your artist name or Spotify URL.`,
            }
        } else {
            basicTextOptions = {
                titleText: 'Get Started',
                descriptionText: DESCRIPTION_INIT_TEXT,
                sectionTitle: `Let's setup your first profile. Enter your artist name or Spotify URL.`,
            }
        }
    }

    const renderBackButton = () => {
        return (
            <BackButton
                className="backButtonFindProfile"
                onBack={() => handleGoBack(history)}
                text={!isFirstTimeOnboarding() ? 'Back to dashboard' : undefined}
            />
        )
    }

    return (
        <>
            <LeftColumn className="leftColumnGetStartedFindBrand" width={mobileView ? "100%" : "50%"} isMobile={mobileView}>
                {showBackButton() && mobileView &&
                    renderBackButton()
                }

                <LogoContainer className="logoContainerGetStartedFindBrand">
                    <SymphonyLogo height={'30px'} />
                </LogoContainer>
                <Titles gap={mobileView ? "8px" : "18px"}>
                    {showBackButton() && !mobileView &&
                        renderBackButton()
                    }
                    <MainTitle className="mainTitleGetStartedFindBrand">{titleText}</MainTitle>
                    <SubTitle className="subTitleGetStartedFindBrand">{descriptionText}</SubTitle>
                </Titles>
                <SpotifyArtistSearch
                    className="spotifyArtistSearchGetStartedFindBrand"
                    title={basicTextOptions.sectionTitle}
                    onClickCreateNewProfile={(profileName: string) => {
                        setSignupWithoutProfileName(profileName)
                        handleGoNext()
                    }}
                    onSelectArtist={(artist, existingBrand) => {
                        if (artist) {
                            setSelectedSpotifyArtist(artist)
                            handleGoNext()
                        } else {
                            setSelectedSpotifyArtist(null)
                        }
                    }}
                />

                <SocialConnectionsButtonsWithModals
                    selectedTikTokProfile={selectedTikTokProfile}
                    selectedInstagramProfile={selectedInstagramProfile}
                    onTikTokSelect={(profile) => setSelectedTikTokProfile(profile)}
                    onInstagramSelect={(profile) => setSelectedInstagramProfile(profile)}
                    onSignupWithoutConnections={setSignupWithoutProfileName}
                    isOnboarding
                />

                {/* only show continue button if the user has connected a tiktok or instagram profile */}
                {(selectedTikTokProfile || selectedInstagramProfile) &&
                    <FixedButtonContainer>
                        <ButtonSymphony
                            className="getStartedFindBrandContinueButton"
                            width={mobileView ? "100%" : 300}
                            disabled={!selectedTikTokProfile && !selectedInstagramProfile}
                            onClick={handleGoNext}
                        >
                            Continue
                        </ButtonSymphony>
                    </FixedButtonContainer>
                }
            </LeftColumn>
            <RightColumn className="rightColumnGetStartedFindBrand" display={mobileView ? 'none' : 'flex'}>
                <LottieContainer>
                    <Lottie
                        options={{
                            loop: true,
                            autoplay: true,
                            animationData: GetStartedLottie,
                        }}
                    />
                </LottieContainer>
            </RightColumn>
        </>
    )
}

export default GetStartedFindBrand;
